function formatShortDate(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString('es-AR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  } catch (_) {
    return String(value);
  }
}

export default function BotEncuestaSurveyList({
  surveys = [],
  selectedId = null,
  isNewDraft = false,
  onSelect,
  onNew,
  showNewButton = false,
  loading = false
}) {
  return (
    <section className="be-survey-list" aria-label="Encuestas generadas">
      <div className="be-survey-list__head">
        <div>
          <h2 className="be-survey-list__title">Encuestas generadas</h2>
          <p className="be-survey-list__sub">
            {surveys.length
              ? `${surveys.length} encuesta${surveys.length === 1 ? '' : 's'} · elegí una para ver o editar`
              : 'Creá una encuesta por cada bot o flujo'}
          </p>
        </div>
        {showNewButton ? (
          <button
            type="button"
            className="be-survey-list__new"
            onClick={onNew}
          >
            + Nueva encuesta
          </button>
        ) : null}
      </div>

      <div className="be-survey-list__scroll" role="list">
        {showNewButton && isNewDraft ? (
          <button
            type="button"
            role="listitem"
            className="be-survey-card be-survey-card--active be-survey-card--draft"
            onClick={onNew}
          >
            <span className="be-survey-card__title">Nueva encuesta</span>
            <span className="be-survey-card__status be-survey-card__status--borrador">Sin guardar</span>
            <span className="be-survey-card__meta">Completá y guardá para generar el link</span>
          </button>
        ) : null}

        {surveys.map((survey) => {
          const active = !isNewDraft && Number(selectedId) === Number(survey.id);
          return (
            <button
              key={survey.id}
              type="button"
              role="listitem"
              className={`be-survey-card${active ? ' be-survey-card--active' : ''}`}
              onClick={() => onSelect(survey.id)}
              title={survey.titulo}
            >
              <span className="be-survey-card__title">{survey.titulo}</span>
              <span className={`be-survey-card__status be-survey-card__status--${survey.estado}`}>
                {survey.estado === 'publicada' ? 'Publicada' : 'Borrador'}
              </span>
              <span className="be-survey-card__meta">
                {Number(survey.total_respuestas || 0)} resp.
                {survey.total_preguntas ? ` · ${survey.total_preguntas} preg.` : ''}
                {' · '}
                {formatShortDate(survey.updated_at)}
              </span>
            </button>
          );
        })}

        {loading && !surveys.length ? (
          <p className="be-survey-list__loading" role="status">Cargando encuestas…</p>
        ) : null}

        {!loading && !surveys.length && !isNewDraft ? (
          <p className="be-survey-list__empty">Todavía no hay encuestas guardadas.</p>
        ) : null}
      </div>
    </section>
  );
}
